import Helmet from 'react-helmet'

const MetaDetail = props => {
  const scripts = []

  if (props.script) {
    props.script.forEach(s => {
      scripts.push(s)
    })
  }

  const title = props.data.meta_data_title || props.data.meta_title || props.data.metadatatitle
  const description = props.data.meta_data_description || props.data.meta_description || props.data.metadatadescription

	console.log('meta atom: ', window.location.href)
  return (
    <Helmet script={scripts}>
      <title>{title}</title>
      <meta name='description' content={description} />
			<link rel='canonical' href={window.location.href} />
    </Helmet>
  )
}

export default MetaDetail



// WEBPACK FOOTER //
// ./src/components/atoms/MetaDetail/index.js